import { Injectable } from '@angular/core';
import { HttpClient, HttpParameterCodec, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { LoginRequest, LoginResponse, UsuarioInfo } from '../models/auth';
import { environment } from '../../../environments/environment';

class CustomHttpParamEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly API = `${environment.apiUrl}/auth`;
  private usuario = new BehaviorSubject<UsuarioInfo | null>(null);

  usuario$ = this.usuario.asObservable();

  constructor(private http: HttpClient) {
    const stored = localStorage.getItem('scajusuario');
    if (stored) {
      this.usuario.next(JSON.parse(stored));
    }
  }

  login(req: LoginRequest): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${this.API}/login`, req).pipe(
      tap(res => this.salvarSessao(res))
    );
  }

entrarComToken(token: string): Observable<LoginResponse> {
  console.log('[AUTH] entrarComToken length:', token?.length ?? 0);
  console.log('[AUTH] entrarComToken prefix:', token?.substring(0, 12) ?? '');

  const params = new HttpParams({ encoder: new CustomHttpParamEncoder() })
    .set('token', token);

  console.log('[AUTH] request URL:', `${this.API}/entrar?token=${encodeURIComponent(token)}`);

  return this.http.get<LoginResponse>(`${this.API}/entrar`, { params }).pipe(
    tap(res => this.salvarSessao(res))
  );
}

  logout(): Observable<void> {
    const refreshToken = localStorage.getItem('scajrefresh') ?? '';
    return this.http.post<void>(`${this.API}/logout`, { refreshToken }).pipe(
      tap(() => this.limparSessao())
    );
  }

  refresh(): Observable<LoginResponse> {
    const refreshToken = localStorage.getItem('scajrefresh') ?? '';
    return this.http.post<LoginResponse>(`${this.API}/refresh`, { refreshToken }).pipe(
      tap(res => this.salvarSessao(res))
    );
  }

  getToken(): string | null {
    return localStorage.getItem('scajtoken');
  }

estaAutenticado(): boolean {
  return !!localStorage.getItem('scajusuario');
}

  limparSessao(): void {
    localStorage.removeItem('scajtoken');
    localStorage.removeItem('scajrefresh');
    localStorage.removeItem('scajusuario');
    this.usuario.next(null);
  }

  get usuarioAtual(): UsuarioInfo | null {
    return this.usuario.value;
  }

get unidadeId(): string {
  const id = this.usuario.value?.unidadeLocalTrabalho?.id;
  return id !== null && id !== undefined ? String(id) : '';
}

  temMenu(url: string): boolean {
    const menuUrls = this.usuario.value?.menuUrls;

    if (!menuUrls || menuUrls.length === 0) {
      return true;
    }

    return menuUrls.includes(url);
  }

  temPermissao(permissao: string): boolean {
    const permissoes = this.usuario.value?.permissoes;

    if (!permissoes || permissoes.length === 0) {
      return true;
    }

    return permissoes.includes(permissao);
  }

  private salvarSessao(res: LoginResponse): void {
    const usuario: UsuarioInfo = {
      ...res.usuario,
      menuUrls: res.usuario?.menuUrls ?? [],
      permissoes: res.usuario?.permissoes ?? []
    };

    localStorage.setItem('scajtoken', res.accessToken);
    localStorage.setItem('scajrefresh', res.refreshToken ?? '');
    localStorage.setItem('scajusuario', JSON.stringify(usuario));
    this.usuario.next(usuario);
  }
}